import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'react-bootstrap/lib/Tabs';
import cns from 'classnames';
import withRestProps from 'helpers/withRestProps';

import cn from './styles.local.less';

class DsbTabs extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    rest: PropTypes.object.isRequired,
  };

  render() {
    const { children, className, rest } = this.props;

    return (
      <Tabs className={cns(cn.root, className)} {...rest}>
        {children}
      </Tabs>
    );
  }
}

export default withRestProps()(DsbTabs);
